export const listReport = {
  table: {
    date: '日付',
    total: '合計',
    inquiry: '問合せ',
    export: 'エクスポート',
    hour: '(単位　ｈ)',
    id: '個人CD',
    fullName: '個人名',
  },
  pageHeader: {
    title: '個人別生産性管理',
  },
  filter: {
    filterDay: '日付別で表示',
    filterByRangeDay: '期間を指定して日別で表示',
    filterByTime: '期間を指定して集計を表示',
    filterEmployee: '個人指定',
    note: '※指定なしを選択する場合、データ量が大きくなる為 \n 1週間以内の期間で問合せしてください。',
    defaultValue: '指定なし',
    gender: '性別',
    position: '職位',
    department: '部署',
  },
  hooks: {
    selectRangeDateFail: '範囲の日付が無効です',
  },
}
